<script lang="ts">
	import Seo from '$lib/components/seo.svelte';

	export let data;

	interface MapIdToName {
		[key: string]: string;
	}

	const mapNames: MapIdToName = {
		'4860575314772997622': 'Greenwood'
	};
</script>

<Seo title={data.character.name} noindex></Seo>

<div class="container py-20">
	<div class="prose prose-lg">
		<h1>{data.character.name}</h1>
		<ul>
			<li>Level: {data.character.level}</li>
			<li>XP: {data.character.experience}</li>
			<li>Last seen at: {mapNames[data.character.map.toString()] ?? 'unknown'}</li>
			{#if data.character.guild}
				<li>Guild: {data.character.guild.name} ({data.character.guild.tag})</li>
			{/if}
		</ul>
	</div>
</div>
